// src/utils/imagePreview.js

/**
 * 图片预览工具函数
 * @param {string} imageUrl - 图片URL
 */
export function previewImage(imageUrl) {
  // 检查是否已经存在预览窗口
  const existingOverlay = document.getElementById('image-preview-overlay');
  if (existingOverlay) {
    document.body.removeChild(existingOverlay);
  }

  // 创建遮罩层
  const overlay = document.createElement('div');
  overlay.id = 'image-preview-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: zoom-out;
  `;

  // 创建图片元素
  const img = document.createElement('img');
  img.src = imageUrl;
  img.style.cssText = `
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
    cursor: zoom-out;
  `;

  // 创建关闭按钮
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '✕';
  closeBtn.style.cssText = `
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: none;
    font-size: 20px;
    cursor: pointer;
    transition: background 0.3s;
  `;

  closeBtn.onmouseover = () => {
    closeBtn.style.background = 'rgba(255, 255, 255, 0.3)';
  };

  closeBtn.onmouseout = () => {
    closeBtn.style.background = 'rgba(255, 255, 255, 0.2)';
  };

  // 关闭预览函数
  const closePreview = () => {
    try {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    } catch (e) {
      // 忽略错误，元素可能已被移除
    }
    
    document.body.style.overflow = 'auto';
    document.removeEventListener('keydown', handleKeyDown);
  };

  // 绑定关闭事件
  closeBtn.onclick = closePreview;
  overlay.onclick = closePreview;
  img.onclick = (e) => e.stopPropagation();

  // 支持ESC键关闭
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closePreview();
    }
  };

  // 添加元素到页面
  overlay.appendChild(img);
  overlay.appendChild(closeBtn);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';
  
  // 监听键盘事件
  document.addEventListener('keydown', handleKeyDown);
}

// 添加到Vue原型链的插件
export default {
  install(Vue) {
    Vue.prototype.$previewImage = previewImage;
  }
};
